export const users = [
  { id: 'u1', name: 'Alex', avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=100&q=80' },
  { id: 'u2', name: 'Jordan', avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=100&q=80' },
  { id: 'u3', name: 'Sam', avatar: 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?auto=format&fit=crop&w=100&q=80' }
];

export const rooms = [
  { id: 'r1', name: 'Kitchen', status: 'warning', temp: '72°F', humidity: '45%' },
  { id: 'r2', name: 'Living Room', status: 'optimal', temp: '70°F', humidity: '40%' },
  { id: 'r3', name: 'Master Bath', status: 'optimal', temp: '74°F', humidity: '60%' },
  { id: 'r4', name: 'Garage', status: 'alert', temp: '60°F', humidity: '55%' }
];

export const chores = [
  { id: 'c1', title: 'Clean HVAC Filter', room: 'Garage', assignee: 'u1', due: 'Today', priority: 'high', completed: false },
  { id: 'c2', title: 'Descale Coffee Maker', room: 'Kitchen', assignee: 'u2', due: 'Tomorrow', priority: 'medium', completed: false },
  { id: 'c3', title: 'Water Indoor Plants', room: 'Living Room', assignee: 'u3', due: 'Today', priority: 'low', completed: true },
  { id: 'c4', title: 'Sanitize Surfaces', room: 'Master Bath', assignee: 'u1', due: 'In 2 days', priority: 'medium', completed: false }
];

export const appliances = [
  { id: 'a1', name: 'Smart Refrigerator', health: 92, nextService: 'Oct 2024', status: 'Online' },
  { id: 'a2', name: 'Washing Machine', health: 45, nextService: 'Overdue', status: 'Warning' },
  { id: 'a3', name: 'HVAC System', health: 78, nextService: 'Jan 2025', status: 'Online' },
  { id: 'a4', name: 'Water Heater', health: 88, nextService: 'Nov 2024', status: 'Online' }
];

export const demoWorkflowSteps = [
  {
    id: 1,
    title: "System Alert",
    description: "AI sensors detect a performance drop in the washing machine bearing.",
    icon: "FiActivity",
    status: "alert",
    action: "Inspect Hardware"
  },
  {
    id: 2,
    title: "Diagnostic Check",
    description: "Review detailed health metrics and service history in the hardware panel.",
    icon: "FiCpu",
    status: "process",
    action: "View Specs"
  },
  {
    id: 3,
    title: "Task Assignment",
    description: "Automated chore creation and assignment to available household member.",
    icon: "FiUserPlus",
    status: "pending",
    action: "Assign to Alex"
  },
  {
    id: 4,
    title: "Inventory Verification",
    description: "System checks if required lubricant and tools are in the home inventory.",
    icon: "FiBox",
    status: "check",
    action: "Check Stock"
  },
  {
    id: 5,
    title: "Maintenance Log",
    description: "Alex completes the fix and logs the action with a photo for warranty.",
    icon: "FiCamera",
    status: "process",
    action: "Submit Log"
  },
  {
    id: 6,
    title: "System Restoration",
    description: "Metrics return to nominal range. Schedule updated and family notified.",
    icon: "FiCheckCircle",
    status: "success",
    action: "Reset Pulse"
  }
];